import { DataTable } from '@/components/dataTable';
import { useDataTable } from '@/components/dataTable/hooks/use-data-table';
import { DataTableToolbar } from '@/components/dataTable/ToolBar';
import { useConfirmationStore } from '@/components/dialog/confirmation.store';
import { useDialogFormStore } from '@/components/dialog/form.store';
import { useDynamicLocale } from '@/hoslog-intl';
import { Advertisement } from '@/services/promos-offers/promos-offers.types';
import * as React from 'react';
import { AdvertiseManagement } from '../../AdvertiseManagement';
import { getAdvertisementColumns } from './Column';

export const AdvertisementTable = ({ data }: { data: Advertisement[] }) => {
  const { openConfirmation } = useConfirmationStore();
  const { onOpen } = useDialogFormStore();
  const { t } = useDynamicLocale();

  const columns = React.useMemo(
    () => getAdvertisementColumns(onOpen, openConfirmation, t),
    [onOpen, openConfirmation, t],
  );

  const onAddnew = () => {
    onOpen({
      modalTitle: 'common.page.modal.manageAdvertisement.title',
      title: 'Manage Advertisement',
      okText: t('common.page.modal.submit'),
      size: 'lg',
      cancelText: t('common.page.button.cancel'),
      component: <AdvertiseManagement />,
    });
  };

  const { table } = useDataTable({
    data,
    columns,
    pageCount: 0,
    initialState: {
      sorting: [{ id: 'id', desc: true }],
    },
    meta: {
      title: t('adManagement.page.table.title'),
      actionKey: 'onAddNew',
      action: onAddnew,
    },
    getRowId: (originalRow) => String(originalRow.id),
    shallow: false,
    clearOnDefault: true,
  });

  return (
    <div>
      <DataTable table={table} className="rounded-t-none rounded-b-xl">
        <DataTableToolbar />
      </DataTable>
    </div>
  );
};
